<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :width="w"
    :top='t'
    :before-close="handleClose"
    class="yi-dialog-root users_dia"
  >
    <div class="slot-dialog-header" slot="title">
      <span class="title">通知用户列表</span>
    </div>
    <div class="dialog-content">
      <vue-scroll :ops="disScrollOpt" ref>
        <div class="users_wrap">
          <div class="user_list clearfix">
            <div class="user_item" :key="i" v-for="(user, i) in list">
              <div :class="['item_wrap', user.is_read ? 'is_readed':'not_readed']">
                <v-icon class="svg" :name="user.is_read ? 'envelope-open': 'envelope'" scale="1.45"></v-icon>
                <div class="name">{{user.receive_name}}</div>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
  </el-dialog>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import "vue-awesome/icons/envelope";
import "vue-awesome/icons/envelope-open";

export default {
  name: "notice-users-dialog",
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
  },
  data() {
    return {
      disScrollOpt: ops(true),
    }
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    t: {
      type: String, 
      default: '20vh'
    },
    w: {
      type: String,
      default: "700px"
    },
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('update:show', false)
      // done()
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/linDialog';
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';
@import '~@/assets/css/mixin';

$item_margin_lr = 15px
$item_margin_b = 15px

.users_dia {
  .dialog-content {
    height: 430px;

    .users_wrap {
      display: block;
      width: 100%;
      padding: 0 20px;
      font-size: $font_size_medium;
      overflow: hidden;

      .user_list {
        color: $color_white;
        display: block;
        margin-right: -($item_margin_lr);
        margin-left: -($item_margin_lr);
        margin-bottom: -($item_margin_b);

        .user_item {
          float: left;
          width: 25%;
          padding-right: $item_margin_lr;
          padding-left: $item_margin_lr;
          box-sizing: border-box;
          margin-bottom: $item_margin_b;

          .item_wrap {
            display: flex;
            width: 100%;
            align-items: center;
            padding: 5px 10px;

            &.is_readed {
              background-color: $color_suc;
            }

            &.not_readed {
              background-color: $color_background_grey;
            }

            .name {
              flex: 1;
              margin-left: 15px;
              over_hide();
              word-break: break-word;
              word-wrap: break-word;
            }

            .svg {
              flex: none;
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
